module.exports = __webpack_public_path__ + "static/media/map.6d527d33.png";